var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6663 0.666656H2.99967C1.53301 0.666656 0.346341 1.86666 0.346341 3.33332L0.333008 24.6667C0.333008 26.1333 1.51967 27.3333 2.98634 27.3333H18.9997C20.4663 27.3333 21.6663 26.1333 21.6663 24.6667V8.66666L13.6663 0.666656ZM16.333 22H5.66634V19.3333H16.333V22ZM16.333 16.6667H5.66634V14H16.333V16.6667ZM12.333 9.99999V2.66666L19.6663 9.99999H12.333Z",
    fill: "#1F2320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.1f561d6b5bfc80683d694a08618b3551.svg";
export { ForwardRef as ReactComponent };